import * as React from 'react'

import { Button } from 'main/ui'
import { Container, HeroTitle, RequestInfoContainer } from './Hero.styles'

interface IProps {
  backgroundImageUrl: string
  schoolName: string
  onClickRequestInfo: () => void
}

export default function Hero(props: IProps) {
  const { backgroundImageUrl, schoolName, onClickRequestInfo } = props

  return (
    <Container backgroundImageUrl={backgroundImageUrl}>
      <HeroTitle>{schoolName}</HeroTitle>
      <RequestInfoContainer>
        <Button full onClick={onClickRequestInfo}>
          Message
        </Button>
      </RequestInfoContainer>
    </Container>
  )
}
